import React from "react";

import copyCodeIcon from "../../../assets/images/copy-code.png";

import { copyTextToClipboard } from "../../../shared/helpers";
import { PrimaryButton } from "../../atoms/Buttons";
import { H3 } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";

const ReferralCopyCodeModal = ({ closeModal }) => {
  const link = `<!doctype html>
    <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office">
  
  <head>
      <meta charset="UTF-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <title>Welcome to MailerLite! </title>`;

  return (
    <ModalHolder width="50%" closeModal={closeModal}>
      <div className="my-10 mx-12">
        <img src={copyCodeIcon} alt="" className="h-24 w-24 mx-auto mb-5" />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Copy Code
        </H3>
        <div
          className="mt-4 mb-8"
          style={{ backgroundColor: "#F8F6FE", border: "1px solid #E5E1F5" }}
        >
          <pre className="px-4 py-6 overflow-x-scroll">
            <code className="text-sm">{link}</code>
          </pre>
        </div>
        <div className="flex items-center justify-center">
          <PrimaryButton onClick={() => copyTextToClipboard(link)}>
            Copy Code
          </PrimaryButton>
        </div>
      </div>
    </ModalHolder>
  );
};

export default ReferralCopyCodeModal;
